// extracted by mini-css-extract-plugin
export default {"title":"loading-screen_title__lCP70","dots":"loading-screen_dots__7jOJa"};